import styled from 'styled-components';
import { color } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import { transparentize } from 'polished';
import { useTranslation } from 'react-i18next';

import useDropdown from '../../../../../lib/hooks/useDropdown';
import Text from '../../../../../shared/Text';
import { useUpdateQuestionStatus } from '../../data';
import defaultAttrs from '../../../../../lib/utils/defaultAttrs';

const statusColor = {
  New: 'notification',
  Contacted: 'warning.default',
  Answered: 'success.default',
};

const StatusSelect = ({
  status,
  questionId,
  tileId,
  activeTab,
  sortBy,
  sortDirection,
}) => {
  const {
    dropdownRef,
    buttonRef,
    showDropdown,
    setShowDropdown,
  } = useDropdown();
  const { mutate } = useUpdateQuestionStatus({
    activeTab,
    tileId,
    questionId,
    sortBy,
    sortDirection,
  });
  const { t } = useTranslation('reports');

  return (
    <Status ref={buttonRef} onClick={() => setShowDropdown(state => !state)}>
      <StatusIcon bg={statusColor[status]} />
      <Text color="black.100" variant="small2">
        {status}
      </Text>
      <DropdownIcon />
      {showDropdown && (
        <Dropdown ref={dropdownRef}>
          <DropdownItem onClick={() => mutate({ newStatus: 'pending' })}>
            {t('questionsTable.statusSelect.new')}
          </DropdownItem>
          <DropdownItem onClick={() => mutate({ newStatus: 'contacted' })}>
            {t('questionsTable.statusSelect.contacted')}
          </DropdownItem>
          <DropdownItem onClick={() => mutate({ newStatus: 'resolved' })}>
            {t('questionsTable.statusSelect.answered')}
          </DropdownItem>
        </Dropdown>
      )}
    </Status>
  );
};

const Status = styled.div`
  border-radius: 100px;
  border: 1px solid ${themeGet('colors.black.40')};
  display: flex;
  align-items: center;
  padding: 3px 8px;
  width: 108px;
  cursor: pointer;
`;

const DropdownIcon = styled.i.attrs(
  defaultAttrs({
    className: 'fa-solid fa-chevron-down fa-xs',
  }),
)`
  margin-left: auto;

  color: ${themeGet('colors.black.80')};
`;

const Dropdown = styled.ul`
  position: absolute;
  border-radius: 8px;
  background: ${themeGet('colors.white')};
  top: 52px;
  z-index: 1;
  left: 0;
  box-shadow: 0px 4px 8px rgba(37, 40, 43, 0.24);
`;

const DropdownItem = styled.li`
  padding: 11px 20px;
  &:hover {
    background: ${props =>
      transparentize(0.6, themeGet('colors.primary.10')(props))} !important;
  }
`;

const StatusIcon = styled.div`
  ${color};
  height: 8px;
  width: 8px;
  border-radius: 50%;
  margin: 0 4px 0 0;
`;

export default StatusSelect;
